import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form, Button, Radio, Divider } from 'semantic-ui-react';

import { Commons } from 'components';
import * as cm_action from 'actions/commons';

import cm from 'helpers/commons';
import storage from 'helpers/storage';
import toastr from 'helpers/toastr';

const propTypes = {};

const defaultProps = {};

class ModAuth extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scope: props.data.staffInfo.auth.type,
      presetIdx: null,
      orgCodeList: null
    };
  }

  componentWillMount() {
    const { authStaffDet } = this.props;

    if (authStaffDet && authStaffDet.data) {
      this.setState({
        presetIdx: authStaffDet.data.presetIdx,
        orgCodeList: authStaffDet.data.orgCodeList
      });
    }
  }

  componentDidMount() {
    cm.mainTitle('권한 및 범위 설정');
  }

  //범위 선택
  scopeChange = (e, { value }) => {
    cm.propsInit(this.props);

    const { authStaffDet } = this.props;
    let presetIdx = 0;
    let orgCodeList = null;

    if (authStaffDet && authStaffDet.data) {
      if (value === 'COMPANY') {
        presetIdx = authStaffDet.data.presetIdx === 1 ? 1 : 0;
        orgCodeList = 0;
      } else {
        presetIdx = authStaffDet.data.presetIdx > 1 ? authStaffDet.data.presetIdx : 0;
        orgCodeList = authStaffDet.data.orgCodeList;
      }
    }

    this.setState({
      scope: value,
      presetIdx,
      orgCodeList
    });
  };

  //권한 변경 완료 버튼
  success = (staffInfo) => {
    const { scope } = this.state;
    const { fn, division, preset } = this.props;
    const companyInfo = ((storage.get('company') || {}).user || {}).company;

    const params = {
      id: staffInfo.id,
      change: {
        type: scope,
        orgCode: null,
        presetIdx: null
      },
      pre: {
        orgCode: staffInfo.auth.organization
      }
    };

    if (scope === 'DIVISION') {
      params['change']['orgCode'] = division && division.value ? division.value : null;
    } else if (scope === 'COMPANY') {
      params['change']['orgCode'] = (companyInfo || {}).id;
    }

    //orgcode가 없을 시
    if (!params['change']['orgCode']) {
      if (scope === 'DIVISION') {
        toastr('top-right', 'warning', '부서를 선택하세요.');
        return;
      }
    }

    //권한을 선택 안했을 때
    if (!preset || !preset.value) {
      toastr('top-right', 'warning', '권한을 선택하세요.');
      return;
    } else {
      params['change']['presetIdx'] = preset.value;
    }

    fn.authStaffMod(params);
  };

  render() {
    const { scope, presetIdx, orgCodeList } = this.state;
    const { data, authStaffDet } = this.props;
    const style = {
      label: {
        width: '100px'
      },
      inputStyle: {
        display: 'block',
        width: '224px'
      }
    };

    const { staffInfo } = this.props.data;

    return (
      <div>
        <Form>
          <Form.Group inline>
            <Form.Field>
              <label style={style.label}>ID</label>
              <p>{staffInfo.signId}</p>
            </Form.Field>
          </Form.Group>
          <Form.Group inline>
            <Form.Field>
              <label style={style.label}>이름</label>
              <p>{staffInfo.name}</p>
            </Form.Field>
          </Form.Group>
          <Form.Group inline>
            <Form.Field>
              <label style={style.label}>부서</label>
              <p>{cm.divisionNavi(staffInfo.orgCode)}</p>
            </Form.Field>
          </Form.Group>
          <Form.Group inline>
            <Form.Field>
              <label style={style.label}>사원번호</label>
              <p>{staffInfo.comIdNum}</p>
            </Form.Field>
          </Form.Group>
          <Divider />
          <Form.Group inline>
            <label style={style.label}>범위 선택</label>
            <Form.Field
              control={Radio}
              label="회사 전체"
              value="COMPANY"
              checked={scope === 'COMPANY'}
              onChange={this.scopeChange}
            />
            <Form.Field
              style={{ marginLeft: '18px' }}
              control={Radio}
              label="부서 단위"
              value="DIVISION"
              checked={scope === 'DIVISION'}
              onChange={this.scopeChange}
            />
          </Form.Group>
          {scope === 'DIVISION' ? (
            <Form.Group inline>
              <label style={style.label}></label>
              <Commons.Division isLabel={false} inputStyle={style.inputStyle} defaultValue={orgCodeList} />
            </Form.Group>
          ) : null}
          <Form.Group inline>
            <label style={style.label}>권한 선택</label>
            <Commons.PresetList inputStyle={style.inputStyle} presetType={scope} defaultValue={presetIdx} />
          </Form.Group>
          <Divider />
          <Button.Group floated="right">
            <Button
              inverted
              color="black"
              style={{ width: 120 }}
              onClick={(e) => {
                this.context.router.history.go('/main/accountManagement');
              }}
            >
              취소
            </Button>
            <Button color="green" style={{ width: 200, marginLeft: 8 }} onClick={(e) => this.success(staffInfo)}>
              완료
            </Button>
          </Button.Group>
        </Form>
      </div>
    );
  }
}

ModAuth.propTypes = propTypes;
ModAuth.defaultProps = defaultProps;

ModAuth.contextTypes = {
  router: PropTypes.object.isRequired
};

ModAuth = connect(
  (state) => ({
    authStaffDet: state.etc.authStaffDet,
    division: state.commons.depth,
    preset: state.commons.preset
  }),
  (dispatch) => ({
    commonFn: bindActionCreators(
      {
        changePreset: cm_action.ReduxDataSet
      },
      dispatch
    )
  })
)(ModAuth);

export default ModAuth;
